module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "List Of Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "abb"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053770_Contents#rabb"
    }
  }, [_vm._v("LIST OF ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Andriamirado, "), _c('i', [_vm._v("Il s’appelait")]), _vm._v(": Sennen Andriamirado, "), _c('i', [_vm._v("Il s’appelait Sankara: Chronique d’une mort violente")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Bamouni, "), _c('i', [_vm._v("Burkina Faso")]), _vm._v(": Babou Paulin Bamouni, "), _c('i', [_vm._v("Burkina Faso: Processus de la Révolution")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CDR: Comité de la Défense de la Révolution (Revolutionary Defense Committee)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CEAO: Communauté Economique de l’Afrique de l’Ouest (Economic Community of West Africa)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CMRPN: Comité Militaire de redressement pour le Progès National (Military Committee for Redressement and National Progress)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CNEC: Centre National d’Entrainement Commandos (National Commando Training Center)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CNR: Conseil National de la Révolution (National Council of the Revolution)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CSB: Confédération syndicale Burkinabé (Burkinabé Union Confederation)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CSV: Confédération syndicale Voltaïque (Voltaic Union Confederation)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("CSP: Conseil du Salut du Peuple (Council of Popular Salvation)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("DOP: Discours d’Orientation Populaire (Political Orientation Speech)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("FESPACO: Festival Panafricain du cinéma de Ouagadougou (Pan-African film festival of Ouagadougou)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("FPV: Front Populaire Voltaïque (Voltaic Popular Front)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("GCB: Group des Communistes Burkinabé (Burkinabé Communists Group)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("GOB: Government of Burkina Faso")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("GOF: Government of France")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("GOUV: Government of Upper Volta")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("IMF: International Monetary Fund")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Jaffré, "), _c('i', [_vm._v("Biographie")]), _vm._v(": Bruno Jaffré, "), _c('i', [_vm._v("Biographie de Thomas Sankara: La Patrie ou la Mort")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("LIPAD: Ligue Patriotique pour le développement (Patriotic league for development)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Martens, "), _c('i', [_vm._v("Sankara, Compaoré")]), _vm._v(": Ludo Martens, "), _c('i', [_vm._v("Sankara, Compaoré et la revolution Burkinabé")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("MLN: Mouvement de Libération Nationale (National Liberation Movement)")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("NGO: Nongovernmental Organizations")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("OAU: Organization of African Unity")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("OCV: Organisation Communiste Voltaïque (Voltaic Communist Organization)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("ONSL: Organisation Nationale des Syndicats Libres (National Organization of Free Trade Unions)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("OPEC: Organization of Petroleum Exporting Countries")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("PAI: Parti Africain de l’Indépendance (African Independence Party)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("PMK: Prytanée Militaire du Kadiogo (Military Academy of Kadiogo)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("PPD: Programme populaire de développement (Popular Development Program)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("PCRV: Parti Communiste Révolutionnaire Voltaïque (Voltaic Revolutionary Communist Party)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("RDA: Rassemblement Démocratique Africain (African Democratic Rally)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("RDP: Révolution Démocratique et Populaire (Democratic and Popular Revolution)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Sankara, "), _c('i', [_vm._v("Oser Inventer")]), _vm._v(": Thomas Sankara, "), _c('i', [_vm._v("Oser Inventer l’avenir, la Parole de Sankara")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Sawadogo, "), _c('i', [_vm._v("Le Président Thomas Sankara")]), _vm._v(": Alfred Sawadogo, "), _c('i', [_vm._v("Le Président Thomas Sankara, Chef de la revolution burkinabé: 1983–1987 Portrait")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("SNEAHV: Syndicat National des Enseignants Africains de Haute-Volta (National Union of African Teachers of Upper Volta)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("Somé, "), _c('i', [_vm._v("Thomas Sankara")]), _vm._v(": Valère Somé, "), _c('i', [_vm._v("Thomas Sankara: L’Espoir Assassiné")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("TPR: Tribunaux Populaires de la revolution (Popular Revolutionary Tribunals)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("UCB: Union des Communistes Burkinabé (Union of Burkinabé Communists)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("UFB: Union des femmes Burkinabé (Union of Burkinabé Women)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("ULC: Union de Lutte Communiste (Union of Communist Struggle)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("ULCR: Union de Lutte Communiste Reconstruite (Union of Communist Struggle—Reconstructed)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("UNAB: Union nationale des anciens du Burkina (National Union of Elders of Burkina)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_vm._v("UNPB: Union national des paysans du Burkina (National Peasants Union of Burkina)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5797a777","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253053770_Abbreviations.vue
// module id = 75
// module chunks = 0